module.exports = __webpack_public_path__ + "static/media/nextSteps.40bd4bce.svg";